import { FC, useEffect, useRef } from 'react';

import { clsx } from 'clsx';

import { useYandexPaySession } from '@shared/hooks/useYandexPaySession';
import { YandexPayType } from '@shared/types/enums/pay.enum';
import { Skeleton } from '@shared/ui/Skeleton';

import cls from './YandexPayWidget.module.scss';

type YandexPayWidgetProps = {
  price: number;
  type?: YandexPayType;
};

export const YandexPayWidget: FC<YandexPayWidgetProps> = ({ price, type = YandexPayType.SPLIT }) => {
  const containerRef = useRef(null);
  const { paymentSession, loaded } = useYandexPaySession({ price, type });

  useEffect(() => {
    if (paymentSession) {
      const YaPay = window.YaPay;
      const isSplit = type === YandexPayType.SPLIT;

      paymentSession.mountWidget(containerRef.current, {
        widgetType: YaPay?.WidgetType.Ultimate,
        widgetTheme: YaPay?.WidgetTheme.Light,
        borderRadius: 20,
        padding: isSplit ? YaPay?.WidgetPaddingType.Default : YaPay?.WidgetPaddingType.None,
        withOutline: isSplit,
        widgetBackground: YaPay?.WidgetBackgroundType.Transparent,
        hideWidgetHeader: false,
        widgetSize: YaPay?.WidgetSize.Medium
      });
    }
  }, [paymentSession, type]);

  return (
    <div className={clsx(cls.wrapper, cls[type.toLowerCase()])}>
      {loaded ? <div ref={containerRef}></div> : <Skeleton />}
    </div>
  );
};
